import type { JobApplicationProcess } from '../services/jobPageApi';

// Earlier stored bundles contain the same six standard stages. Combine those
// into the three conversations shown in the design without dropping a custom process.
const legacyTitles = ['Online-Bewerbung', 'Erstgespräch', 'Fachliches Interview', 'Praktische Herausforderung', 'Abschlussgespräch', 'Willkommen im Team'];

export function jobDisplayTitle(title: string): string {
  return title.replace(/^Deine Karriere als\s+/i, '').trim();
}

export function applicationSteps(process: JobApplicationProcess) {
  const steps = process.steps ?? [];
  if (steps.length !== legacyTitles.length || !steps.every((step, index) => step.title === legacyTitles[index])) return steps;
  return [
    { id: 'kennenlernen', step: '01', title: 'Kennenlernen', description: 'Nach deiner Bewerbung sprechen wir in einem ersten 15-minütigen Video-Call über dich, deine Motivation, deine Erfahrungen und deine Fragen.' },
    { id: 'fachgespraech', step: '02', title: 'Fachlicher Austausch', description: 'Du besprichst deine Erfahrungen und Projekte mit dem Fachbereich. Je nach Rolle kann eine praxisnahe Aufgabe dazukommen.' },
    { id: 'angebot', step: '03', title: 'Abschluss & Angebot', description: 'Du lernst das Führungsteam kennen und klärst offene Fragen. Wenn es für beide Seiten passt, erhältst du ein Vertragsangebot.' },
  ];
}

export function jobSlugFromPath(pathname: string): string {
  const path = pathname.replace(/\/$/, '');
  const index = path.indexOf('/job/');
  if (index < 0) return '';
  try { return decodeURIComponent(path.slice(index + 5)); } catch { return ''; }
}
